<script setup>
import { useStore } from "vuex";
import { defineEmits, computed, onMounted, ref } from "vue";
import SearchableSelectComponent from "@/components/SearchableSelectComponent.vue";

const store = useStore();
const localValue = ref();
const emit = defineEmits(["update:modelValue"]);
const courses = computed(() => {
  const allCourses = store.getters["courses/getCourseNames"];
  return allCourses;
});

onMounted(async () => {
  await store.dispatch("courses/fetchCourseNames");
});

const onChange = (value) => {
  localValue.value = value;
  emit("update:modelValue", value);
};
</script>

<template>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <span class="text-sm"><b>Course Name</b></span>
        <SearchableSelectComponent
          v-model="localValue"
          :options="courses"
          label="name"
          track-by="id"
          placeholder="Please Select Course"
          @update:modelValue="onChange"
        />
      </div>
    </div>
  </div>
</template>
